import React from 'react';
import { IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const RecognizeItemButton = ({ onClick }) => {
  return (
    <IconButton
      onClick={onClick}
      size="medium"
      aria-label="Cikk felismerése"
      sx={{
        backgroundColor: 'primary.main',
        color: 'common.white',
        '&:hover': {
          backgroundColor: 'primary.dark',
        },
      }}
    >
      <AddIcon fontSize="medium" />
    </IconButton>
  );
};

export default RecognizeItemButton;
